import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { gettype } from "../redux-toolkit/Slice/typeSlice";
import { GET_type, POST_product, PUT_product } from "../redux-toolkit/ApiEndpoint";
import { addproduct, updateproduct } from "../redux-toolkit/Slice/productSlice";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddProduct = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { title, label1, placeholder1, label2, placeholder2, Editdata } = location.state || {};

    console.log(Editdata, "Editdata");

    useEffect(() => {
        dispatch(gettype({
            endpoint: GET_type
        }));
    }, []);

    let { typedata } = useSelector((state) => state.productType);

    // Set up state for form inputs
    const [productName, setProductName] = useState(Editdata?.productname || "");
    const [productType, setProductType] = useState(Editdata?.productType?.uuid || "");

    const handleaddproduct = (e) => {
        e.preventDefault();

        if (Editdata) {
            // Update the product if Editdata is present
            dispatch(updateproduct({
                endpoint: PUT_product,
                uuid: Editdata.uuid, // Assuming Editdata contains a `uuid` field
                payload: {
                    productname: productName,
                    productTypeuuid: productType,
                },
            }))
                .unwrap()
                .then(() => {
                    toast.success('Product updated successfully!');
                })
                .catch((error) => {
                    toast.error(error || 'Failed to update Product. Please try again.');
                });
        } else {
            // Add a new product if Editdata is not present
            dispatch(addproduct({
                endpoint: POST_product,
                payload: {
                    productname: productName,
                    productTypeuuid: productType,
                },
            }))
                .unwrap()
                .then(() => {
                    toast.success('Product added successfully!');
                })
                .catch((error) => {
                    toast.error(error || 'Failed to add Product. Please try again.');
                });
        }

        navigate("/");
    };

    return (
        <section className="page-padding">
            <div className="container-fluid">
                <div className="col-lg-10">
                    <div className="form-wrapper" data-aos="fade-right" data-aos-duration="3000">
                        <h2 className="title">{title}</h2>
                        <div className="col-12">
                            <hr />
                        </div>
                        <form onSubmit={handleaddproduct}>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-12 mb-4">
                                    <label htmlFor="SelectProductType" className="mb-2">{label2}</label>
                                    <select
                                        className="form-select"
                                        name="SelectProductType"
                                        aria-label="Product Type"
                                        value={productType}
                                        onChange={(e) => setProductType(e.target.value)}
                                    >
                                        <option value="">{placeholder2}</option>
                                        {typedata && typedata.length > 0 ? typedata.map((type, index) => {
                                            return (
                                                <option key={index} value={type.uuid}>{type.typename}</option>
                                            );
                                        }) : (
                                            <option value="">No Product Type</option>
                                        )}
                                    </select>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-4">
                                    <label htmlFor="InputProductName" className="mb-2">{label1}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="InputProductName"
                                        placeholder={placeholder1}
                                        value={productName}
                                        onChange={(e) => setProductName(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-12 d-flex gap-3">
                                    <button
                                        className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase border border-0"
                                        type="submit"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AddProduct;

